import { Dashboard } from '@app/tenants/dashboard'
import { DeletionLogs } from '@app/tenants/deletion-logs'
import { PendingDeletions } from '@app/tenants/pending-deletions'
import { Tenant } from '@app/tenants/tenant'
import { Route, Routes } from 'react-router'

export const Tenants = () => {
  return (
    <Routes>
      <Route path="/" element={<Dashboard />} />
      <Route path="/pending-deletions" element={<PendingDeletions />} />
      <Route path="/deletion-logs" element={<DeletionLogs />} />
      <Route path="/:tenantId" element={<Tenant />} />
    </Routes>
  )
}
